import { useMutation } from "@tanstack/react-query"
import { Account } from "pages/ManageAccounts"
import HTTPClient from "services/HTTPClient"

export interface IMedia {
    url: string
    name: string
}


export interface IReadingAssessment {
    id: number
    paragraph: string
    title: string
    topic: string
    image?: IMedia
}

export interface IReadingAssessmentResponse {
    accuracy: number
    comprehension: number
    id: number
    notes: string
    transcript: string
    user: Account
    words_per_minute: number
    audio?: IMedia
    reading_assessment: IReadingAssessment
    quiz_session: {
        score_percentage: number
        topic: string
        id: number
    }
}

const useReadingAssessmentResponse = () => {
    return useMutation({
        mutationFn: async ({ user_ids, grade, assessment_id }: { user_ids?: number[], grade?: string, assessment_id?: number }): Promise<IReadingAssessmentResponse[]> => {
            const url = `/api/tenant/getAssessmentResponses`
            let body = {
                user_ids,
                grade,
                assessment_id
            }
            let response = await HTTPClient.get().postDataForJSONResult(url, body)
            console.log(response)
            return response.map(a => ({ ...a, key: a.id }))
        }
    })
};

export default useReadingAssessmentResponse;